import axios from 'src/utils/axiosHelper';
import authService from 'src/services/authService';
import {
  commonLogURL,
  commonV2URL,
  commonV3URL,
  message
} from 'src/constantsMessage';
import { SET_ALERT } from 'src/actions/alertAction';
import { sendVerificationEmail } from './registerActions';
import { formDataToencode64Base } from 'src/context/constantMethod';
import { VERIFY_PAYMENT_EMPTY } from 'src/actions/subscriptionActions';
import { REGISTER_EMPTY } from 'src/actions/registerActions';
import helperAxios from 'src/utils/helperAxios';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const UPDATE_PROFILE = '@account/update-profile';
export const SEND_MAIL = '@account/send-mail';
export const SEND_MAIL_FAIL = '@account/send-mail-fail';
export const SEND_MAIL_EMPTY = '@account/send-mail-empty';
export const RESET_PASSWORD = '@account/reset-password';
export const RESET_PASSWORD_FAIL = '@account/reset-password-fail';
export const RESET_EMPTY = '@account/reset-empty';
export const UPDATE_PASSWORD = '@account/update-password';
export const UPDATE_PASSWORD_FAIL = '@account/update-password-fail';
export const UPDATE_PASSWORD_EMPTY = '@account/update-password-empty';
export const LOADER = '@account/loader';
export const LOGIN_SUCCESS_WITH_ACCESS_TOKEN =
  '@account/login-success-with-access-token';
export const LOGIN_SUCCESS_WITH_ACCESS_TOKEN_DONE =
  '@account/login-success-with-access-token-done';

export const GENERATE_OTP_DATA = '@account/generate-otp-data';
export const GENERATE_OTP_DATA_ERROR = '@account/generate-otp-data-error';
export const VERIFY_OTP_DATA = '@account/verify-otp-data';
export const SUBMIT_NEW_PASSWORD = '@account/submit-new-password';

export function login(
  email,
  password,
  clientId,
  rememberMe,
  captchaText,
  captchaRequestUUID
) {
  return async dispatch => {
    try {
      dispatch({ type: LOGIN_REQUEST });
      dispatch({ type: LOADER });
      clientId
        ? await authService.adminLoginWithClientId(
            email,
            password,
            clientId,
            rememberMe
          )
        : captchaRequestUUID
        ? await authService.loginWithEmailAndPassword(
            email,
            password,
            rememberMe,
            captchaText,
            captchaRequestUUID
          )
        : await authService.loginWithEmailAndPassword(
            email,
            password,
            rememberMe
          );

      const user = await authService.loginInWithToken();
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user
        }
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      error.response &&
        error.response.data.error !== 'Invalid Email' &&
        error.response &&
        error.response.data.error !== 'Wrong password' &&
        error.response &&
        error.response.data.error !== 'Incorrect captcha.' &&
        error.response &&
        error.response.data.error !==
          'Captcha expired. Refresh and try again.' &&
        error.response &&
        error.response.data.error !==
          'You have exceeded the maximum number of attempts for this captcha. Refresh and try again.' &&
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          linkAction: () => dispatch(sendVerificationEmail(email))
        });
      throw error;
    }
  };
}

export function sendMail(email) {
  const url = `${commonV2URL}/user/forgotPassword?userEmail=${email}`;
  const request = helperAxios(url, 'post');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: SEND_MAIL,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: SEND_MAIL_FAIL,
          payload: error.response && error.response.data
        });
      });
  };
}

export function sendMailEmpty() {
  return dispatch => {
    dispatch({ type: SEND_MAIL_EMPTY });
  };
}

export function onResetPassword(password, confirmPassword, token) {
  const data = {
    newPassword: password,
    confirmPassword: confirmPassword
  };
  let requestBody = formDataToencode64Base(data);
  const request = axios({
    method: 'post',
    url: `${commonV2URL}/user/resetPassword?resetPasswordToken=${token}`,
    data: requestBody
  });

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: RESET_PASSWORD,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.passwordUpdate
        });
      })
      .catch(error => {
        dispatch({
          type: RESET_PASSWORD_FAIL,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function resetEmpty() {
  return dispatch => {
    dispatch({ type: RESET_EMPTY });
  };
}

export function onUpdatePassword(values) {
  const data = {
    currentPassword: values.currentPassword,
    newPassword: values.password
  };
  let requestBody = formDataToencode64Base(data);

  const url = `${commonV2URL}/user/updatePassword`;
  const request = helperAxios(url, 'post', requestBody);
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: UPDATE_PASSWORD,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: UPDATE_PASSWORD_FAIL,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function onUpdatePasswordEmpty() {
  return dispatch => {
    dispatch({ type: UPDATE_PASSWORD_EMPTY });
  };
}

export function setUserData(user) {
  return dispatch =>
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user
      }
    });
}

export function logout() {
  localStorage.removeItem('items');
  return async dispatch => {
    const url = `/api/auth/logout`;
    await helperAxios(url, 'post');
    authService.logout();
    dispatch({ type: REGISTER_EMPTY });
    dispatch({ type: VERIFY_PAYMENT_EMPTY });
    dispatch({
      type: LOGOUT
    });
  };
}

export function loginWithSocialOauth(responseSocialOuth, provider) {
  return async dispatch => {
    dispatch({
      type: LOADER
    });
    let idToken = '';
    if (provider === 'google') {
      idToken = responseSocialOuth.tokenObj.id_token;
    } else if (provider === 'linkedIn') {
      idToken = responseSocialOuth.code;
    }
    await axios({
      method: 'post',
      url: `api/auth/login/social`,
      data: {
        idToken,
        provider
      }
    })
      .then(async response => {
        authService.setSession(response.data.token);
        try {
          const user = await authService.loginInWithToken();
          dispatch({
            type: LOGIN_SUCCESS,
            payload: {
              user
            }
          });
        } catch (error) {
          dispatch({ type: LOGIN_FAILURE });
          setTimeout(() => {
            dispatch({
              type: SET_ALERT,
              payload: error.response && error.response.data,
              payload1: 'error'
            });
          }, 500);
          throw error;
        }
      })
      .catch(error => {
        dispatch({ type: LOGIN_FAILURE });
        setTimeout(() => {
          dispatch({
            type: SET_ALERT,
            payload: error.response && error.response.data,
            payload1: 'error'
          });
        }, 500);
      });
  };
}

export function loginThroughVerification(token) {
  const request = axios({
    method: 'post',
    url: `${commonV3URL}/subscription/generateToken?access-t=${token}`
  });

  return async dispatch => {
    dispatch({
      type: LOADER,
      payload: 'Success! Your account is verified. Logging in now...'
    });

    try {
      const response = await request;
      authService.setSession(response.data.token);
      const user = await authService.loginInWithToken();

      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user }
      });
      dispatch({
        type: LOGIN_SUCCESS_WITH_ACCESS_TOKEN
      });
      // const request1 = axios({
      //   method: 'post',
      //   url: `${commonLogURL}/logs`,
      //   data: {
      //     entityStatus: 'AUTO_LOGIN_ON_VERIFY_ACCOUNT'
      //   }
      // });
      // request1.then(response => {}).catch(error => {});
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
    }
  };
}

export function authLoginDone() {
  return dispatch => {
    dispatch({
      type: LOGIN_SUCCESS_WITH_ACCESS_TOKEN_DONE
    });
  };
}

export function sendClientOTP(clientId) {
  const data = {
    clientId: clientId,
    type: 'generateOTP'
  };
  const base64Data = formDataToencode64Base(data);
  const request = axios({
    method: 'post',
    url: `/api/auth/verifyClient`,
    data: base64Data
  });

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: GENERATE_OTP_DATA,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GENERATE_OTP_DATA_ERROR,
          payload: error?.response?.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function verifyClientOTP(clientId, otpData, captcha) {
  const data = {
    clientId: clientId,
    type: 'verifyOTP',
    otp: otpData,
    captchaText: captcha,
    captchaRequestUUID: localStorage.getItem('captchaRequestUUID')
  };
  const base64Data = formDataToencode64Base(data);
  const request = axios({
    method: 'post',
    url: `/api/auth/verifyClient`,
    data: base64Data
  });

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        if (response?.data?.message === 'INVALID') {
          dispatch({
            type: SET_ALERT,
            payload: 'Invalid OTP',
            payload1: 'error'
          });
        } else if (response?.data?.message === 'VALID') {
          dispatch({
            type: SET_ALERT,
            payload: 'OTP verified, mobile number confirmed successfully',
            payload1: 'success'
          });
        }
        dispatch({
          type: VERIFY_OTP_DATA,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({ type: LOGIN_FAILURE });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function submitNewPassword(clientId, password) {
  const data = {
    clientId: clientId,
    password: password
  };
  const base64Data = formDataToencode64Base(data);
  const request = axios({
    method: 'post',
    url: `/api/bsa/v2/user/setPassword`,
    data: base64Data
  });

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(async response => {
        dispatch({
          type: SUBMIT_NEW_PASSWORD,
          payload: response.data
        });
        dispatch({
          type: LOADER,
          payload: 'Password update successful. Logging in now...'
        });

        try {
          if (response?.data?.token) {
            authService.setSession(response?.data?.token);
            const user = await authService.loginInWithToken();

            dispatch({
              type: LOGIN_SUCCESS,
              payload: { user }
            });
            dispatch({
              type: LOGIN_SUCCESS_WITH_ACCESS_TOKEN,
              payload: true
            });
          } else {
            dispatch({ type: LOGIN_FAILURE });
          }
        } catch (error) {
          dispatch({ type: LOGIN_FAILURE });
        }
      })
      .catch(error => {
        dispatch({ type: LOGIN_FAILURE });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
